import { init as initApm } from '@elastic/apm-rum'
import { version } from 'settings/version.json'

export const apm = initApm({
  serviceName: process.env.REACT_APP_ELK_APM_SERVICE_NAME,
  serverUrl: 'https://elk-apm.telavita.com.br/',
  serviceVersion: version,
  environment: process.env.REACT_APP_ELK_APM_ENVIRONMENT,
})